import { toast } from 'react-toastify';

export const VALID_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const isValidImageFormat = (file: File): boolean => {
  if (!file) return false;
  return VALID_IMAGE_TYPES.includes(file.type);
};

export const validateAndAlertImageFormat = (file: File): boolean => {
  if (!isValidImageFormat(file)) {
    toast.error('Invalid file format. Please upload a JPG, PNG, or WebP image.');
    return false;
  }
  return true;
};
